import { Button, ChevronLeftSVG } from "@newsela/angelou";
import PropTypes from "prop-types";

import { withTrackEvent } from "@newsela/snitch";
import focusElementRefKeys from "@/view/constants/focusElementRefKeys";
import useFocusManager from "@/view/utils/useFocusManager";
import { rootCss, labelCss, iconCss } from "./PanelHeaderBackButton.style";

const propTypes = {
  eventProperties: PropTypes.object,
  label: PropTypes.string,
  onClick: PropTypes.func,
};

const ButtonWithTrackEvent = withTrackEvent(Button);

const PanelHeaderBackButton = ({ eventProperties = {}, label, onClick }) => {
  const { setFocusManagerRef } = useFocusManager();

  return (
    <ButtonWithTrackEvent
      ariaProps={{ "aria-label": "Back to previous panel screen" }}
      __cssFor={{ root: rootCss, icon: iconCss }}
      icon={{
        SvgComponent: ChevronLeftSVG,
        alignment: Button.iconAlignments.left,
      }}
      flavor={Button.flavors.incognito}
      onClick={onClick}
      {...eventProperties}
      ref={(ref) =>
        setFocusManagerRef(ref, focusElementRefKeys.activityPanelBackButton)
      }
    >
      <span css={labelCss}>{label}</span>
    </ButtonWithTrackEvent>
  );
};

PanelHeaderBackButton.propTypes = propTypes;

export default PanelHeaderBackButton;
